export const isErrorResponse = (res) => {
    return res.error != null;
};
//# sourceMappingURL=utils.js.map